import { render, staticRenderFns } from "./FLoginForm.vue?vue&type=template&id=850767a8&scoped=true&"
import script from "./FLoginForm.vue?vue&type=script&lang=js&"
export * from "./FLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./FLoginForm.vue?vue&type=style&index=0&id=850767a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850767a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VTextField})
